import { render, staticRenderFns } from "./BlockContent.vue?vue&type=template&id=cacc096a"
import script from "./BlockContent.vue?vue&type=script&lang=js"
export * from "./BlockContent.vue?vue&type=script&lang=js"
import style0 from "./BlockContent.vue?vue&type=style&index=0&id=cacc096a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports